import { createAction } from '@gef-ui/utils/fsaActions';
import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { globalErrorAction } from '../../constants';
import { composeAction } from '../../utils';
/**
 * Update global errors for given form
 *
 * @documented
 * @category Action
 * @example
 *
 * 	updateGlobalErrors('negotiationForm')('Ahoj')
 *
 */ export const updateGlobalErrors = memoizeWithIdentity((formName)=>createAction(composeAction(formName, globalErrorAction.UPDATE_GLOBAL_ERRORS)));
/**
 * clear global errors for given form
 *
 * @documented
 * @category Action
 * @example
 *
 * 	clearGlobalErrors('negotiationForm')() // clear all errors
 *	clearGlobalErrors('negotiationForm')({ fieldName: 'foo.bar' }) // clear errors of one field
 *	clearGlobalErrors('negotiationForm')({ uniqueID: '123456' }) // clear only one error
 */ export const clearGlobalErrors = memoizeWithIdentity((formName)=>createAction(composeAction(formName, globalErrorAction.CLEAR_GLOBAL_ERRORS)));
